module.exports = __webpack_public_path__ + "entry-150bfe9b/miriam--djambou.256x256-da2af2994cac2c67cba231378a2541ec.webp";